import * as Yup from 'yup';

export const getDueDateExtensionRequestSchema = () => {
  return Yup.object().shape({
    date: Yup.string().required('Date is required'),
    time: Yup.string().required('Time is required'),
  });
};
export const getApproveAndCloseSchema = (modalName: string) => {
  if (modalName === 'request-review-approve') {
    return Yup.object().shape({
      description: Yup.string(),
    });
  } else {
    return Yup.object().shape({
      description: Yup.string().required('Reason is required'),
    });
  }
};
export const getRejectActionSchema = () => {
  return Yup.object().shape({
    date: Yup.string().required('Date is required'),
    time: Yup.string().required('Time is required'),
    description: Yup.string().required('Description is required'),
  });
};

export const getCorrectiveActionsDetailsSchema = () => {
  return Yup.object().shape({
    description: Yup.string().required('Description is required'),
    files: Yup.array()
      .max(3, 'Maximum 3 files allowed')
      .of(
        Yup.mixed()
          .test('is-file', 'Value must be a file', (value) => {
            if (!value) return true;
            return typeof File !== 'undefined' && value instanceof File;
          })
          .test('fileSize', 'File too large', function (value) {
            const { path, createError } = this;
            if (!value || !(value instanceof File)) return true;

            const isVideo = value.type?.startsWith('video/');
            const maxSize = isVideo ? 50 * 1024 * 1024 : 5 * 1024 * 1024;

            if (value.size > maxSize) {
              return createError({
                path,
                message: `${value.name} exceeds the maximum size limit of ${isVideo ? '50MB (video)' : '5MB'}`,
              });
            }

            return true;
          }),
      )
      .test('maxFiles', 'Maximum 3 files allowed', (value) => {
        if (value && value.length > 3) {
          return false;
        }
        return true;
      }),
  });
};
